<template>
  <page-view title>
    <div slot="headerContent">
      <search-robot @changeRobotId="onChangeRobotId"></search-robot>
    </div>
    <exception-page type="norobot" v-if="!currentRobotId"/>
    <a-card :bordered="false" v-if="currentRobotId">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="查询条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择查询条件" allowClear>
                  <a-select-option value="1">邀请人微信昵称</a-select-option>
                  <a-select-option value="2">邀请人微信id</a-select-option>
                  <a-select-option value="3">被邀请人微信昵称</a-select-option>
                  <a-select-option value="4">被邀请人微信id</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="查询内容">
                <a-input v-model="queryParam.keywords" placeholder="请输入查询内容"/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator"></div>
      <s-table ref="table" rowKey="id" :columns="columns" :data="loadData">
        <span slot="sourcenickname" slot-scope="text">{{text || '无'}}</span>
        <span slot="sourceusername" slot-scope="text">
          {{text || '无'}}
        </span>
        <span slot="sourceInfo" slot-scope="record">
          <template v-if="record.sourcenickname">
            <span v-line-clamp="1">昵称：{{record.sourcenickname}}</span>
            <span v-line-clamp="1">wxid：{{record.sourceusername}}</span>
          </template>
          <span v-else>无</span>
        </span>
        <span slot="fromInfo" slot-scope="record">
          <span v-line-clamp="1">昵称：{{record.fromnickname}}</span>
          <span v-line-clamp="1">wxid：{{record.fromusername}}</span>
          <span v-line-clamp="1">备注：{{record.content||'无'}}</span>
        </span>
      </s-table>
    </a-card>
  </page-view>
</template>

<script>
import { STable } from '@/components'
import SearchRobot from '@/views/components/SearchRobot'
import FansApi from '@/api/fans'
import { PageView } from '@/layouts'
import { ExceptionPage } from '@/components'
export default {
  name: 'newFans',
  components: {
    PageView,
    STable,
    FansApi,
    SearchRobot,
    ExceptionPage
  },
  data() {
    return {
      currentRobotId: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '机器人ID',
          dataIndex: 'sub_id'
        },
        {
          title: '邀请人信息',
          scopedSlots: { customRender: 'sourceInfo' },
          width:300
        },
        {
          title: '被邀请人信息',
          scopedSlots: { customRender: 'fromInfo' }
        },
				
        // {
        //   title: '邀请人微信id',
        //   dataIndex: 'sourceusername',
        //   scopedSlots: { customRender: 'sourceusername' }
        // },
        // {
        //   title: '被邀请人微信昵称',
        //   dataIndex: 'fromnickname',
        // },
        // {
        //   title: '被邀请人微信id',
        //   dataIndex: 'fromusername',
        // },
        // {
        //   title: '好友申请备注',
        //   dataIndex: 'content',
        //   scopedSlots: { customRender: 'content' }
        // },
        {
          title: '状态',
          dataIndex: 'state',
          scopedSlots: { customRender: 'state' }
        },
		{
		  title: '申请时间',
		  dataIndex: 'create_time',
		},
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return FansApi.getNewfansList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId
          })
        )
      },
    }
  },
  created() {},
  activated(){
  },
  methods: {
    onChangeRobotId(id) {
      this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
</style>
